import { MapPin, Phone, Lock } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_d28fa793-233b-4071-af00-df1c1e1b0bba/artifacts/6t4csq6x_Logo_Komel%20AG.png";

const footerLinks = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Referenzen", href: "#referenzen" },
  { label: "Kontakt", href: "#kontakt" },
];

const Footer = ({ onImpressum, onDatenschutz }) => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-komel-primary text-white py-12 pb-24 lg:pb-12" data-testid="footer">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Main Footer Content - 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8 items-start">
          {/* Logo */}
          <div className="flex items-start pt-1">
            <img 
              src={LOGO_URL} 
              alt="Komel AG" 
              className="h-36 md:h-42 w-auto brightness-0 invert"
            />
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Navigation</h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/70 hover:text-komel-accent transition-colors text-sm"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Kontakt</h4>
            <div className="space-y-2 text-sm text-white/70">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>
                  Multergasse 2a<br />
                  9000 St. Gallen
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a 
                  href="tel:+41712261199"
                  className="hover:text-komel-accent transition-colors"
                >
                  071 226 11 99
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Description */}
        <p className="text-white/50 text-sm mb-8">
          Total- und Generalunternehmerin in St. Gallen. Bauen, Sanieren, Renovieren – alles aus einer Hand.
        </p>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {currentYear} Komel AG. Alle Rechte vorbehalten.
          </p>
          
          <div className="flex items-center gap-6 text-sm">
            <button
              onClick={onImpressum}
              className="text-white/50 hover:text-white transition-colors"
              data-testid="footer-impressum"
            >
              Impressum
            </button>
            <button
              onClick={onDatenschutz}
              className="text-white/50 hover:text-white transition-colors"
              data-testid="footer-datenschutz"
            >
              Datenschutz
            </button>
            <Link
              to="/admin"
              className="text-white/50 hover:text-white transition-colors flex items-center gap-1.5"
              data-testid="footer-admin-login"
            >
              <Lock className="w-3.5 h-3.5" />
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
